import React, { useEffect, useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header";
import RecentlyCreatedLeads from "./components/RecentlyCreatedLeads";
import { useStages } from "../../crmSetting/stages/hooks/useStages";
import { useDispatch, useSelector } from "react-redux";
import { MODULES } from "../../../core/data/constants/moduleConstants";
import LeadsByStagePieChart from "./components/LeadsByStagePieChart";
import LeadsByDateBarChart from "./components/LeadsByDateBarChart";
import LeadsByStagesBarChart from "./components/LeadsByStagesBarChart";
import LeadsByMonthBarChart from "./components/LeadsByMonthBarChart";
import CompanyFilter from "../../../core/common/crmComponents/CompanyFilter";
import LeadsByYearGraph from "./components/LeadsByYearGraph";
import { useSearchParams } from "react-router-dom";
import LeadsSourceCount from "./components/LeadsSourceCount";
import LeadsSourceCountTable from "./components/LeadSourceCountTable";
import { Drawer } from "@mui/material";
import PowerBiDashboard from "./components/PowerBiDashborad";
import queryClient from "../../../config/queryClient";
import { setReloading } from "../../../core/data/redux/moduleDataSlice";

const LeadsDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { companyNameArr } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const reloading = useSelector((state) => state.moduleData.reloading);

  const { user } = useSelector((state) => state?.auth);
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const companyIdFromParams = searchParams.get("companyid");

    return companyIdFromParams
      ? companyIdFromParams
      : user?.ofCompany
      ? user?.ofCompany?._id
      : companyNameArr.length > 0
      ? companyNameArr[0].value
      : null;
  });

  const { stagesData } = useStages({
    ofCompany: selectedCompany,
    module: MODULES.LEADS,
  });

  const stages = stagesData?.data?.data;

  const [open, setOpen] = useState(false);
  function handleClickOpen() {
    setOpen(true);
  }
  function handleClose() {
    setOpen(false);
  }

  useEffect(() => {
    if (reloading) {
      queryClient.invalidateQueries();
      dispatch(setReloading(false));
    }
  }, [reloading, dispatch]);

  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center ">
                  <div className="col-md-4">
                    <h3 className="page-title">
                      Leads Dashboard
                      {/* create a btn hear and on click open MUI drawer */}
                      {/* i want full screen dialog of MUI */}
                      {/* <h3 className="page-title">
                        Leads Dashboard
                        <button
                          className="btn btn-primary"
                          onClick={handleClickOpen}
                        >
                          Add New
                        </button>


                      <button
                        className="btn btn-primary"
                        onClick={handleClickOpen}
                      >
                        Add New
                      </button>
                      <Drawer
                        anchor={"right"}
                        open={open}
                        onClose={handleClose}
                      >
                        <div className="drawer-content">
                          <div className="drawer-header">
                            <h4>Dashboard</h4>
                          </div>
                          <div className="drawer-body">
                            <iframe
                              title="BBC_Dashbord"
                              width="100%"
                              height="100%"
                              src="https://app.powerbi.com/reportEmbed?reportId=dbb18b05-a86f-44fe-8d63-370a675401bf&autoAuth=true&ctid=763564f3-fc2e-475d-b9a3-6472f1a2d3c7"
                              frameborder="0"
                              allowFullScreen="true"
                            ></iframe>
                            Microsoft Power BI
                          </div>
                        </div>
                      </Drawer>
                    </h3> */}
                    </h3>
                  </div>

                  <div className="col-md-8 float-end ms-auto">
                    <div className="d-flex gap-2 title-head">
                      <PowerBiDashboard />

                      <CompanyFilter
                        selectedCompany={selectedCompany}
                        setSelectedCompany={setSelectedCompany}
                        user={user}
                      />
                      <div className="daterange-picker d-flex align-items-center justify-content-center">
                        <div className="head-icons mb-0">
                          <CollapseHeader />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <LeadsSourceCount selectedCompany={selectedCompany} />
            <LeadsSourceCountTable selectedCompany={selectedCompany} />
          </div>

          <div className="row">
            <RecentlyCreatedLeads selectedCompany={selectedCompany} />
            <LeadsByDateBarChart
              stages={stages}
              selectedCompany={selectedCompany}
            />
          </div>

          <div className="row">
            <LeadsByStagesBarChart
              stages={stages}
              selectedCompany={selectedCompany}
            />

            <LeadsByStagePieChart
              stages={stages}
              selectedCompany={selectedCompany}
            />
          </div>
          <div className="row">
            <LeadsByYearGraph selectedCompany={selectedCompany} />
            <LeadsByMonthBarChart selectedCompany={selectedCompany} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadsDashboard;
